
    import { defineComponent, PropType } from 'vue'
    import { iOlapCustomView } from '../Olap'
    import { filterDefault } from '@/helpers/commons/filterHelper'
    import Column from 'primevue/column'
    import DataTable from 'primevue/datatable'
    import olapCustomViewTableDescriptor from './OlapCustomViewTableDescriptor.json'

    export default defineComponent({
        name: 'olap-custom-view-table',
        components: { Column, DataTable },
        props: { olapCustomViews: { type: Object as PropType<iOlapCustomView[]> } },
        emits: ['close', 'applyCustomView'],
        data() {
            return {
                olapCustomViewTableDescriptor,
                customViews: [] as iOlapCustomView[],
                filters: { global: [filterDefault] } as Object,
                loading: false
            }
        },
        watch: {
            olapCustomViews() {
                this.loadCustomViews()
            }
        },
        created() {
            this.loadCustomViews()
        },
        methods: {
            loadCustomViews() {
                this.customViews = this.olapCustomViews as iOlapCustomView[]
            },
            applyCustomView(customView: iOlapCustomView) {
                this.$emit('applyCustomView', { subobj_id: customView.id, subobj_name: customView.name, subobj_description: customView.description, subobj_visibility: customView.isPublic })
            },
            deleteCustomViewsConfirm(customView: iOlapCustomView) {
                this.$confirm.require({
                    message: this.$t('common.toast.deleteMessage'),
                    header: this.$t('common.toast.deleteConfirmTitle'),
                    icon: 'pi pi-exclamation-triangle',
                    accept: async () => this.deleteCustomView(customView)
                })
            },
            async deleteCustomView(customView: iOlapCustomView) {
                this.loading = true
                await this.$http
                    .delete(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `/1.0/olapsubobjects/removeOlapSubObject?idObj=${customView.id}`)
                    .then(() => {
                        this.removeCustomView(customView)
                        this.$store.commit('setInfo', {
                            title: this.$t('common.toast.deleteTitle'),
                            msg: this.$t('common.toast.deleteSuccess')
                        })
                    })
                    .catch(() => {})
                this.loading = false
            },
            removeCustomView(customView: iOlapCustomView) {
                const index = this.customViews.findIndex((el: iOlapCustomView) => el.id === customView.id)
                if (index !== -1) this.customViews.splice(index, 1)
            },
            close() {
                this.$emit('close')
                this.customViews = []
            }
        }
    })
